import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainDiasLibresComponent } from './main-dias-libres/main-dias-libres.component';
import { ListaDiasLibresComponent } from './lista-dias-libres/lista-dias-libres.component';
import { AgregarDiasLibresComponent } from './agregar-dias-libres/agregar-dias-libres.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSortModule } from '@angular/material/sort';
import { HelperModule } from 'src/app/helper.module';
import { PrimeNgModule } from 'src/app/PrimeNg.module';
import { AutonumericModule } from '@angularfy/autonumeric';



@NgModule({
  declarations: [
    MainDiasLibresComponent,
    ListaDiasLibresComponent,
    AgregarDiasLibresComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    MatCardModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    MatSortModule,
    HelperModule,
    PrimeNgModule,
    AutonumericModule.forRoot(),
  ],
  exports: [
    MainDiasLibresComponent,
    ListaDiasLibresComponent,
    AgregarDiasLibresComponent
  ]
})
export class DiasLibresModule { }
